// src/pages/DynamicLandingPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
// doc, getDoc, setDoc ve serverTimestamp eklendi:
import { collection, query, where, getDocs, updateDoc, increment, doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore'; 
import { db } from '../config/firebaseConfig';
import { Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import NotFound from './NotFound';

const DEFAULT_IMAGE = 'https://studio.littlehibba.com/images/sajeda/6.jpg';

const DynamicLandingPage = () => {
    const { slug } = useParams();
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const q = query(collection(db, 'customPages'), where('slug', '==', slug));
                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    setNotFound(true);
                } else {
                    const pageDoc = querySnapshot.docs[0];
                    setPageData(pageDoc.data());

                    // --- GELİŞMİŞ TEKİL ZİYARETÇİ (UNIQUE IP + LOCALSTORAGE) TAKİBİ ---
                    const pageId = pageDoc.id;
                    const localKey = `lh_viewed_${pageId}`;

                    // KATMAN 1: Tarayıcı bu sayfayı daha önce açtı mı?
                    if (!localStorage.getItem(localKey)) {
                        try {
                            // KATMAN 2: IP Adresini öğren
                            const ipRes = await fetch('https://api.ipify.org?format=json');
                            const { ip } = await ipRes.json();

                            if (ip) {
                                // Firestore döküman ID'lerinde nokta (.) ve iki nokta (:) yasaktır. 
                                // Örn: 192.168.1.1  -->  192_168_1_1 haline getirilir.
                                const safeIp = ip.replace(/[.:]/g, '_');
                                const visitorRef = doc(db, 'customPages', pageId, 'visitors', safeIp);
                                const visitorSnap = await getDoc(visitorRef);

                                if (!visitorSnap.exists()) {
                                    // IP veritabanında yok! Gerçekten yeni bir ziyaretçi.
                                    await setDoc(visitorRef, { visitedAt: serverTimestamp(), ip });
                                    await updateDoc(pageDoc.ref, { viewCount: increment(1) });
                                }

                                // Cihaz veritabanında olsa da olmasa da tarayıcıya "Görüldü" damgası vur
                                localStorage.setItem(localKey, 'true');
                            }
                        } catch (err) {
                            // Adblocker IP servisini engellerse site çökmek yerine analitiği pas geçsin
                            console.warn("Analytics skipped:", err.message);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching landing page:", error);
                setNotFound(true);
            } finally {
                setLoading(false);
            }
        };

        fetchPage();
    }, [slug]);

    if (loading) return <div className="min-vh-100 d-flex justify-content-center align-items-center"><Spinner animation="border" variant="primary" /></div>;
    if (notFound || !pageData) return <NotFound />;

    return (
        <div className="w-100 p-0 m-0" style={{ backgroundColor: '#fdfdfd', overflowX: 'hidden' }}>
            <Helmet>
                <title>{pageData.title} | Little Hibba</title>
                {pageData.seoDescription && <meta name="description" content={pageData.seoDescription} />}
                {pageData.seoKeywords && <meta name="keywords" content={pageData.seoKeywords} />}
            </Helmet>
            
            {pageData.contentModules?.map((block) => {
                const s = block.style || {};
                
                return (
                    <div key={block.id} className="w-100">
                        
                        {block.type === 'heading' && (
                            <div className="container py-3">
                                <h2 className={`text-${s.align} fw-bolder mb-0`} style={{ color: s.color, fontSize: `${s.fontSize}px`, fontFamily: "'Playfair Display', serif" }}>{block.content}</h2>
                            </div>
                        )}

                        {block.type === 'text' && (
                            <div className="container py-2">
                                <p className={`text-${s.align} mb-0`} style={{ color: s.color, fontSize: `${s.fontSize}px`, whiteSpace: 'pre-wrap', lineHeight: '1.8' }}>{block.content}</p>
                            </div>
                        )}

                        {block.type === 'image' && (
                            <div className="container py-4">
                                <div className={`text-${s.align}`}>
                                    <img src={block.content || DEFAULT_IMAGE} alt="Visual Element" className="img-fluid shadow-sm mx-auto" style={{ width: `${s.width}%`, borderRadius: `${s.borderRadius}px`, objectFit: 'cover', display: 'inline-block' }} />
                                </div>
                            </div>
                        )}

                        {block.type === 'video' && (
                            <div className="container py-4">
                                <div className={`text-${s.align}`}>
                                    <div className="d-inline-block w-100" style={{ maxWidth: `${s.width}%`, borderRadius: `${s.borderRadius}px`, overflow: 'hidden', verticalAlign: 'top' }}>
                                        {block.content && block.content.toLowerCase().includes('.mp4') ? (
                                            <video controls className="w-100 shadow-sm" style={{ borderRadius: `${s.borderRadius}px` }}>
                                                <source src={block.content} type="video/mp4" />
                                            </video>
                                        ) : (
                                            <div className="ratio ratio-16x9 shadow-sm" style={{ borderRadius: `${s.borderRadius}px`, overflow: 'hidden' }}>
                                                <iframe src={block.content?.replace("watch?v=", "embed/")} title="Video Block" allowFullScreen style={{ border: 'none' }}></iframe>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {block.type === 'button' && (
                            <div className="container py-3">
                                <div className={`text-${s.align}`}>
                                    <a href={block.url || '#'} className="btn shadow-sm fw-bold px-5 py-2 d-inline-block" style={{ backgroundColor: s.bgColor, color: s.textColor, fontSize: `${s.fontSize}px`, borderRadius: `${s.borderRadius}px`, border: 'none', letterSpacing: '1px' }}>{block.content}</a>
                                </div>
                            </div>
                        )}

                        {block.type === 'html' && (
                            <div className="w-100 p-0 m-0" dangerouslySetInnerHTML={{ __html: block.content }} />
                        )}

                        {block.type === 'columns' && (
                            <div className="w-100 py-5" style={{ backgroundColor: s.bgColor }}>
                                <div className="container">
                                    <div className="row g-4 align-items-center">
                                        {block.columns.map((col, i) => (
                                            <div key={i} className={`col-md-${12 / block.colCount} text-center`}>
                                                {col.image && <img src={col.image || DEFAULT_IMAGE} alt="Column Visual" className="img-fluid mb-4 rounded-4 shadow-sm" style={{ maxHeight: '250px', objectFit: 'cover' }} />}
                                                <h4 className="fw-bold mb-3" style={{ color: s.textColor, fontFamily: "'Playfair Display', serif" }}>{col.title}</h4>
                                                <p className="mb-0" style={{ color: s.textColor, opacity: 0.8, lineHeight: '1.7' }}>{col.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                );
            })}
        </div>
    );
};

export default DynamicLandingPage;